// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d6AS","col":"styles_col__XBCHr"};